import { useContext } from "react";
import ProductLicenseFormContext from "core/context/ProductLicenseFormContext";

const useProductLicenseForm = () => {
  const context = useContext(ProductLicenseFormContext);

  if (context === undefined) {
    throw Error(
      "useProductLicenseForm must be used within a ProductLicenseFormProvider!"
    );
  }

  return context;
};

export default useProductLicenseForm;
